// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".actions-tip{position:absolute;z-index:2;display:flex;flex-direction:column;padding:8px 16px;background:#fff;border-radius:12px}", ""]);
// Exports
module.exports = exports;
